export default [
  {
    path: '/crm-system',
    name: 'crm-system',
    // Audit P1-2: the CRM landing page is the salesperson's real start of day,
    // not a placeholder. HomeCRM.vue kept on disk but no longer routed.
    redirect: { name: 'crm-system-my-day' },
    meta: {
      title: 'CRM System',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/pipeline',
    name: 'crm-system-pipeline',
    component: () => import('@/views/crm/pipeline/PipelineCRM.vue'),
    meta: {
      title: 'CRM Pipeline',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/contacts',
    name: 'crm-system-contacts',
    component: () => import('@/views/crm/contacts/ContactsCRM.vue'),
    meta: {
      title: 'CRM Contacts',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/contacts/edit/:id',
    name: 'crm-system-contact-edit',
    component: () => import('@/views/crm/contacts/EditContactCRM.vue'),
    meta: {
      title: 'Edit Contact',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/contacts/show/:id',
    name: 'crm-system-contact-show',
    component: () => import('@/views/crm/contacts/ShowContactCRM.vue'),
    meta: {
      title: 'Contact Details',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/companies',
    name: 'crm-system-companies',
    component: () => import('@/views/crm/companies/CompaniesCRM.vue'),
    meta: {
      title: 'CRM Companies',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/companies/show/:id',
    name: 'crm-system-company-show',
    component: () => import('@/views/crm/companies/ShowCompanyCRM.vue'),
    meta: {
      title: 'Company Details',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/ongoing-requests',
    name: 'crm-system-ongoing-requests',
    component: () => import('@/views/crm/ongoing-requests/OngoingRequestsCRM.vue'),
    meta: {
      title: 'Ongoing Requests',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/leads',
    name: 'crm-system-leads',
    component: () => import('@/views/crm/leads/LeadsCRM.vue'),
    meta: {
      title: 'Leads Details',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/my-day',
    name: 'crm-system-my-day',
    component: () => import('@/views/crm/my-day/MyDayCRM.vue'),
    meta: {
      title: 'My Day',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/tasks',
    name: 'crm-system-tasks',
    component: () => import('@/views/crm/tasks/TasksCRM.vue'),
    meta: {
      title: 'Tasks',
      crmSystem: true,
    },
  },
  {
    // MID-CRM: quotations existed only inside a card drawer — there was no way to
    // see "what have we quoted". This is the list view.
    path: '/crm-system/quotations',
    name: 'crm-system-quotations',
    component: () => import('@/views/crm/quotations/QuotationsCRM.vue'),
    meta: {
      title: 'Quotations',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/products',
    name: 'crm-system-products',
    component: () => import('@/views/crm/products/ProductsCRM.vue'),
    meta: {
      title: 'Products & Prices',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/campaigns',
    name: 'crm-system-campaigns',
    component: () => import('@/views/crm/campaigns/CampaignsCRM.vue'),
    meta: {
      title: 'Campaigns',
      crmSystem: true,
    },
  },
  {
    path: '/crm-system/dashboard',
    name: 'crm-system-dashboard',
    component: () => import('@/views/crm/dashboard/DashboardCRM.vue'),
    meta: {
      title: 'Sales Dashboard',
      crmSystem: true,
    },
  },
  {
    // MID-CRM D1/D2/D3 — target vs actual per technical regulation, the analysis
    // Ms Airen keeps in "A. MARKETING _ FOR MS. AIREN ONLY.xlsx". Needs the
    // workbook imported first (php artisan crm:import-marketing-workbook).
    path: '/crm-system/targets',
    name: 'crm-system-targets',
    component: () => import('@/views/crm/targets/TargetsCRM.vue'),
    meta: {
      title: 'Targets & Progress',
      crmSystem: true,
    },
  },
]
